import { SensitiveMoney } from "@/components/common/Sensitive";
import {
  formatOverweightStepRange,
  formatOverweightSurchargeAmount,
} from "@/lib/ratePolicies";
import type { OverweightStep } from "@/types/api";

/** One overweight tier row with privacy masking on the surcharge amount. */
export function OverweightStepLabel({
  step,
  currency,
  className,
}: {
  step: Pick<
    OverweightStep,
    "min_kg" | "max_kg" | "surcharge" | "currency"
  >;
  currency: string;
  className?: string;
}) {
  const cur = step.currency || currency;
  const range = formatOverweightStepRange(step);
  const amount = formatOverweightSurchargeAmount(step.surcharge);

  return (
    <span className={className}>
      {range} · {cur}{" "}
      <SensitiveMoney formatted={amount} />
    </span>
  );
}
